import { Component, OnInit, signal } from "@angular/core";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LoadingService } from "@core/loading.service";
import { ModalController } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { Subscription, take } from "rxjs";
import { StoreRepositoryService } from "src/app/pages/store/store-repository.service";
import { PaymentService } from "src/app/services/payment.service";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
    selector: "app-syndicate-loading",
    templateUrl: "./syndicate-loading.component.html",
    styleUrls: ["./syndicate-loading.component.scss"],
    standalone: true,
    imports: [
        LottieComponent,
        MatProgressBar,
        TranslatePipe,
    ],
})
export class SyndicateLoadingComponent implements OnInit {
  showLoader = false;
  showProgressBar = false;
  progress = 0;
  loaderOptions: AnimationOptions = {
    path: "./../../../../assets/ticket-loading.json",
    loop: true,
  };
  ticketGenerated = false;
  initialTicketCount = 0;
  currentTicketCount = 0;
  initialCountUpdated = false;
  private trackUserManagedTicketsSubscription: Subscription;
  public selectedLanguage: string;
  syndiacatePaymentSuccsesful = signal(false)

  constructor(
    private modalCtrl: ModalController,
    private storeService: StoreRepositoryService,
    private authService: AuthService,
    private router: Router,
    private loadingService: LoadingService,
    private translate: TranslateService,
    private paymentService: PaymentService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    // Get Customer Purchase Details
    const encryptedId = this.paymentService.cashPurchaseCustomerPurchaseId$.getValue();
    this.paymentService.getCustomerPurchaseDetailsFromEncryptedCpId(encryptedId)
    .pipe(take(1))
    .subscribe((data:Data) => {
      const purchaseDoc = data?.payload?.data();
      if (purchaseDoc?.processed_status === 2) this.syndiacatePaymentSuccsesful.set(true)
    });

    this.trackUserManagedTicketsSubscription = this.storeService.trackUserManagedTickets().subscribe(
      (res) => {
        if (!res) {
          this.initialTicketCount = 0;
          this.currentTicketCount = 0;
          this.initialCountUpdated = true;
          return;
        }
        if (!this.initialCountUpdated) {
          this.initialTicketCount = res.length;
          this.currentTicketCount = res.length;
          this.initialCountUpdated = true;
        } else {
          this.currentTicketCount = res.length;
        }

        if ((this.initialTicketCount !== this.currentTicketCount) && this.syndiacatePaymentSuccsesful()) {
          this.ticketGenerated = true;
          this.unsubscribeFromTrackUserManagedTickets();
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {
    this.showLoader = true;
    this.showProgressBar = true;
    const waitInterval = setInterval(() => {
      this.progress += 1;
      if (this.ticketGenerated || this.progress > 45) {
        if (this.progress > 45) {
          this.showErrorToast();
          this.unsubscribeFromTrackUserManagedTickets();
          this.loadingService.present();
        }
        this.showLoader = false;
        this.showProgressBar = false;
        clearInterval(waitInterval);
        this.modalCtrl.dismiss({ saveTicket: true }).catch((err) => {
          return err;
        });
        return;
      }
    }, 1000);
  }

  showErrorToast() {
    // Payment Error Message
    const encryptedId = this.paymentService.cashPurchaseCustomerPurchaseId$.getValue();
    this.paymentService.paymentErrorMessage(encryptedId);
  }

  private unsubscribeFromTrackUserManagedTickets(): void {
    if (this.ticketGenerated || this.progress > 45) {
      this.trackUserManagedTicketsSubscription?.unsubscribe();
    }
  }
}
